import { ViewModel,View } from "binder"
import  { SetReceiptBillsPriceView } from "./setReceiptBillsPrice-view"
import { IPopup } from "src/common/userMainWindow/windowContainer/IPopup";
import { WarehouseSelectorViewModel } from "../warehouseManipulation/warehouseManipulation-viewModel";
import { ServerConnection } from "src/server/serverConnection";
import { downloadFile, getAsNumber } from "src/uicomponents/components/utilities";
import { stringIsNullOrEmpty } from "src/common/utilities";

export class SetReceiptBillsPriceViewModel extends ViewModel implements IPopup{
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
        // this.warehouseSelector = new WarehouseSelectorViewModel(this);
        // this.warehouseSelector.onSelectionChanged = w =>{
        //     this.warehouseId = w.id;
        // }
    }
    closePopup(result: boolean = false) {
       
    }
    GetDefaultView(): View <ViewModel> {
        return new SetReceiptBillsPriceView();
    }
    public getTypeId(): string {
        return "VM-FBC6770F-6504-49D8-9C5E-D5AA82668B34"
    }
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    // public set warehouseSelector(v: WarehouseSelectorViewModel) { this._warehouseSelector = v; } public get warehouseSelector(): WarehouseSelectorViewModel { return this._warehouseSelector;} private _warehouseSelector: WarehouseSelectorViewModel;
    // public set warehouseId(v: string) { this._warehouseId = v; } public get warehouseId(): string { return this._warehouseId;} private _warehouseId: string;
    public set billNoFrom(v: number) { 
        this._billNoFrom = getAsNumber(v, true);  
    } public get billNoFrom(): number { return this._billNoFrom; } private _billNoFrom: number;
    public set billNoUntil(v: number) { 
        this._billNoUntil = getAsNumber(v, true);  
    } public get billNoUntil(): number { return this._billNoUntil; } private _billNoUntil: number;

    
    back() {
        this.closePopup();
    }

    async confirm() {
        try {
            this.isLoading = true;
            let result = await ServerConnection.callServer('Complex/WarehouseServices/UpdateAllReceiptPrices', {
                // WarehouseId: this.warehouseId,
                ReceiptCodeFrom: this.billNoFrom,
                ReceiptCodeUntil: this.billNoUntil
            });
            if(result.IsSuccessful){
                if (stringIsNullOrEmpty(result.FaultBillCode) == false) {
                    await this.messageBoxConfirmWarning(`رسید به شماره ${result.FaultBillCode} با مشکل مواجه شد و به صورت دستی باید آپدیت شود.`,'خطا');
                } else {
                    await this.messageBoxConfirmSuccess("قیمت های همه ی رسیدهای انبار با موفقیت بروزرسانی شد.", "بروزرسانی قیمت رسید انبار");
                }
                this.closePopup(true);
            } else {
                await this.messageBoxConfirmWarning("خطایی در روند بروزرسانی رخ داد.",'خطا');
            }
        } catch (ex) {
            console.log(ex);
            await this.messageBoxConfirmWarning("خطایی در روند بروزرسانی رخ داد.",'خطا');
        } finally {
            this.isLoading = false;
        }
    }

}
